export default __webpack_public_path__ + "static/media/bear_8.44827b61.png";